import { Button } from '@/lib/base/buttons/button';

interface NewMessagesButtonProps {
  onClick: () => void;
}

/** Pinned above the composer when new content arrives while scrolled up. */
export function NewMessagesButton({ onClick }: NewMessagesButtonProps) {
  return (
    <div className='flex justify-center pb-2'>
      <Button
        onClick={onClick}
        className='flex items-center gap-1.5 px-3 py-1.5 rounded-full shadow-lg'
        size='sm'
        aria-label='Scroll to new messages'
      >
        New messages ↓
      </Button>
    </div>
  );
}
